import {Pipe, PipeTransform} from "@angular/core";
import {Product} from "./product";

@Pipe({
    name: 'filterProductByChildrenProduct',
    standalone: false
})
export class FilterProductByChildrenProductPipe implements PipeTransform {

  transform(products: Product[], parentId: number): Product[] {
    let filteredProducts: Product[];

    filteredProducts = products.filter((product: Product): boolean => product.productId && product.productId == parentId);
    return filteredProducts;
  }

}
